import React, { useState, useEffect, useRef } from "react";
import FullLoading from "../../../../components/full-loading3";
import "./index.less";
import PopupModelCenter, {
  PopupModelProps
} from "../../../../components/popup-model-center";
import { getWaitWithdrawAmount, applyWithdraw, getUserInfo } from "../../api";
import { encryptBankCardNo } from "../../utils";
import Toast from "@xpeng/rc-toast";
import { goToPage } from "../../../../utils/common";
import { trackGdp } from "../../../../utils/gio-report";
import ContactService from "../../../../components/contact-service";
const realization = () => {
  const { origin, pathname } = window.location;
  const [visible, setVisible] = useState(false);
  const [popupModelData, setPopupModelData] = useState<PopupModelProps>({});
  const [amount, setAmount] = useState(0); // 余额
  const [withdrawalAmount, setWithdrawalAmount] = useState(0); // 提现金额
  const [cardNum, setCardNum] = useState(""); // 卡号
  const InputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    document.title = "提现";
    trackGdp('P20143', 'B001')
    getWaitWithdrawAmount({}).then(res => {
      if ([0, 200].includes(res.code)) {
        setAmount(res.data?.amount || 0);
      }
    });
    getUserInfo({}).then(res => {
      if (
        [0, 200].includes(res.code) &&
        res.data?.userCardRelaDto?.bankAccount
      ) {
        setCardNum(encryptBankCardNo(res.data?.userCardRelaDto?.bankAccount));
      }
    });
    setTimeout(() => {// goback回到页面时，会出现输入框有值，但是提现金额没有赋值的情况，所以加个延时确保一致
      if(InputRef.current && InputRef.current.value){
        setWithdrawalAmount(Number(InputRef.current.value));
      }
    }, 0);
  }, []);
  // 提现
  const onfirm = () => {
    trackGdp('P20143', 'B002')
    if (!withdrawalAmount) {
      return;
    }
    if (Number(withdrawalAmount) < 20) {
      Toast.show("最低提现金额为20元");
      return;
    }
    FullLoading.show({
      text: "请稍后"
    });
    applyWithdraw({ amount: withdrawalAmount })
      .then(res => {
        if ([0, 200].includes(res.code) && res.data?.businessWithdrawId) {
          goToPage(
            `${origin}${pathname}#/realization-detail?businessWithdrawId=${res.data.businessWithdrawId}`
          );
        } else {
          setVisible(true);
          setPopupModelData({
            popupTitle: "提现失败",
            content: <div>很抱歉，提现失败了，失败原因：{res.msg}</div>,
            leftBtnText:(<ContactService>
              <div style={{color: 'rgba(0, 0, 0, 0.9)'}}>咨询客服</div>
            </ContactService>),
            leftBtnFun: () => {},
            rightBtnText: "好的",
            rightBtnFun: () => {
              setVisible(false);
            }
          });
        }
      })
      .finally(() => {
        FullLoading.hide();
      });
  };

  return (
    <div className="realization-content">
      <div className="content">
        <div className="card-num">提现卡号：{cardNum}</div>
        <div className="title">提现金额</div>
        <div className="input-item">
          <span style={{ marginRight: 24 }}>¥</span>
          <input
            ref={InputRef}
            className="input"
            type="number"
            onChange={e => {
              if (Number(e.target.value) > amount && InputRef.current) {
                InputRef.current.value = amount + "";
                setWithdrawalAmount(amount);
                return;
              }
              // 如果超过两位小数，不让继续输入小数位
              if (e.target.value.includes(".") && e.target.value.split(".")[1]?.length > 2 && InputRef.current) {
                InputRef.current.value = withdrawalAmount + "";
                setWithdrawalAmount(withdrawalAmount);
                return;
              }
              // 开头为0，不让继续输入
              if (e.target.value.startsWith("0") && InputRef.current) {
                InputRef.current.value = withdrawalAmount + "";
                setWithdrawalAmount(withdrawalAmount);
                return;
              }
              setWithdrawalAmount(Number(e.target.value));
            }}
          />
        </div>
        <div className="tips tips-bottom">
          <span>可提现金额：¥{amount} </span>
          {!!amount && (
            <span
              style={{ color: "#5A960A" }}
              onClick={() => {
                if (InputRef.current) {
                  InputRef.current.value = amount + "";
                  setWithdrawalAmount(amount);
                }
              }}
            >
              全部提现
            </span>
          )}
        </div>
        <div className="tips">
          <div>提现须知： </div>
          <div>1. 订单收益为【已到账】才可提现，最低提现门槛为20元</div>
          <div>
            2. 提现受理成功后，到账时间取决于收款银行，有疑问请咨询银行客服
          </div>
        </div>
      </div>

      <div className="btn-item" onClick={onfirm}>
        <div
          className="btn"
          style={{
            backgroundColor: withdrawalAmount ? "#181916" : "rgb(197,197,197)"
          }}
        >
          提现
        </div>
      </div>
      <PopupModelCenter
        visible={visible}
        popupTitle={popupModelData.popupTitle}
        content={popupModelData.content}
        leftBtnText={popupModelData.leftBtnText}
        rightBtnText={popupModelData.rightBtnText}
        leftBtnFun={popupModelData.leftBtnFun}
        rightBtnFun={popupModelData.rightBtnFun}
      />
    </div>
  );
};
export default realization;
